import Abstract from '../../framework/Abstract';

import './F2-account-update.scss';

class F2AccountUpdate extends Abstract {

	constructor(config) {
		super(config);

		this.classes = {
			btn: 'btn',
			form: 'form',
		};
	}

	addWaitingButton = (element) => {
		const anchor = document.createElement('a');
		anchor.setAttribute('href', '#');
		anchor.setAttribute('class', 'btn btn--primary u-center');
		anchor.innerHTML = '<div class="loading"><div class="loading__dots">Loading...</div></div>';
		anchor.addEventListener('click', (event) => { event.preventDefault(); });
		element.appendChild(anchor);
	}

	onSubmit = (event) => {
		const { btn } = this.classes;
		const button = event.target.querySelector(`.${btn}`);
		event.target.removeChild(button);
		this.addWaitingButton(event.target);
	}

	attachEvents = () => {
		const { root } = this.config;
		const { form } = this.classes;
		const forms = root.querySelectorAll(`.${form}`);

		Array.from(forms).forEach((formEl) => {
			formEl.addEventListener('submit', this.onSubmit);
		});
	}

	init() {
		this.attachEvents();
	}
}

export default F2AccountUpdate;
